import { loadStripe, Stripe } from '@stripe/stripe-js';

const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

if (!STRIPE_PUBLISHABLE_KEY) {
  throw new Error(
    'Missing VITE_STRIPE_PUBLISHABLE_KEY. Set it in your .env.local before running the app.'
  );
}

if (!STRIPE_PUBLISHABLE_KEY.startsWith('pk_')) {
  // Guards against accidental use of a secret key on the client.
  throw new Error('VITE_STRIPE_PUBLISHABLE_KEY must be a publishable key (pk_…).');
}

let stripePromise: Promise<Stripe | null> | undefined;

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};
